import React from 'react'
import { PopoverFooter } from '@chakra-ui/core'
import { RootState } from 'constants/interfaces'
import { useSelector } from 'react-redux'
import { NoFocusButton } from '../NoFocusButton'
import LocaleText from 'components/LocaleText'

interface Props {
  onSubmit: () => void
  isDisabled: boolean
}

const SUBMIT_BUTTON_STYLES = {
  w: '200px' as const,
  h: 'max-content' as const,
  p: '4px' as const,
  color: 'white' as const,
  borderRadius: '5px' as const,
}

export const GroupedSelectFooter: React.FC<Props> = ({ onSubmit, isDisabled }) => {
  const theme = useSelector((state: RootState) => state.general.theme)

  return (
    <PopoverFooter display="flex" justifyContent="center">
      <NoFocusButton {...SUBMIT_BUTTON_STYLES} bg={theme?.elementsColor} onClick={onSubmit} isDisabled={isDisabled}>
        <LocaleText text="select_group_select_button" />
      </NoFocusButton>
    </PopoverFooter>
  )
}
